/** Same GFM `- ` strip as Copy button `copyWithFullFormatWithoutListsV2`. */
export const removeListMarkers = (markdown: string): string =>
  markdown.replace(/^- /gm, '');
